import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

export const API = `${BACKEND}/api`;

const VIEWER_BLOCKED_METHODS = ["post", "put", "patch", "delete"];
const VIEWER_ALLOWED_PATHS = ["/auth/login", "/auth/logout", "/auth/password"];

function isViewerRole() {
  try {
    const token = localStorage.getItem("access_token");
    if (!token) return false;
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload?.role === "demo_viewer";
  } catch {
    return false;
  }
}

const api = axios.create({
  baseURL: API,
  withCredentials: false,
});

// Attach Bearer token; block mutations for demo_viewer in the client layer too
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  const method = (config.method || "").toLowerCase();
  if (VIEWER_BLOCKED_METHODS.includes(method)) {
    const path = (config.url || "");
    const isAllowed = VIEWER_ALLOWED_PATHS.some((p) => path.startsWith(p));
    if (!isAllowed && isViewerRole()) {
      const err = new Error("Bu hesap yalnızca inceleme erişimine sahiptir.");
      err.isViewerBlock = true;
      return Promise.reject(err);
    }
  }
  return config;
});

export function formatApiError(err) {
  if (err?.code === "ERR_NETWORK") return "Sunucuya ulaşılamadı. Bağlantınızı kontrol edip tekrar deneyin.";
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Bir hata oluştu.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

api.interceptors.response.use(response => response, error => {
  if (error?.response?.status === 401 && error.config?.url !== "/auth/login") {
    window.dispatchEvent(new Event("auth-expired"));
  }
  return Promise.reject(error);
});

export default api;
